import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterCityList = () => {
  const cityList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-city/list', payload, response => {
      if (response.status_code === 200) {
        const { data } = response
        callback(data)
      }
    })
  }, [])

  return { cityList }
}

export default InteractorMasterCityList
